import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const adminHeader = () => {
  const token = localStorage.getItem("zelaya_admin_token");
  return token ? { "X-Admin-Password": token } : {};
};

export const submitContact = (payload) => api.post("/contact", payload).then((r) => r.data);
export const getSiteInfo = () => api.get("/site/info").then((r) => r.data);
export const getGallery = (category) =>
  api.get("/gallery", { params: category && category !== "all" ? { category } : {} }).then((r) => r.data);

export const adminLogin = (password) => api.post("/admin/login", { password }).then((r) => r.data);
export const listContacts = () => api.get("/contact", { headers: adminHeader() }).then((r) => r.data);
export const deleteContact = (id) => api.delete(`/contact/${id}`, { headers: adminHeader() }).then((r) => r.data);
export const addGallery = (payload) => api.post("/gallery", payload, { headers: adminHeader() }).then((r) => r.data);
export const deleteGallery = (id) => api.delete(`/gallery/${id}`, { headers: adminHeader() }).then((r) => r.data);
